// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__27G1L","modalForm":"UpgradeEpcsModal_modalForm__w9KX4","modalFooter":"UpgradeEpcsModal_modalFooter__2i1Nm"};